import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

export const query = gql`
  query SuperchargerTextSettings($gameId: Int!) {
    superchargerTextSettings(gameId: $gameId)
  }
`;

// The caller may not have a supercharger_enrollment yet (e.g. payment flow
// not completed), which errors this field - kept as its own query so that
// error doesn't wipe out unrelated game data fetched elsewhere.
export function useSuperchargerTextSettingsQuery({ gameId, pollInterval }) {
  const { data, loading, error, refetch } = useQuery(query, {
    skip: !gameId,
    variables: { gameId },
    pollInterval,
  });

  return {
    superchargerTextSettings: data?.superchargerTextSettings || null,
    loading,
    error,
    refetch,
  };
}
